// removed by extract-text-webpack-plugin
module.exports = {"container":"profession__container___2LnUY","suggestionContainer":"profession__suggestionContainer___AT64L","suggestion":"profession__suggestion___2zcgD","suggestionFocused":"profession__suggestionFocused___6cJ8R","sectionSuggestionsContainer":"profession__sectionSuggestionsContainer___2YS-8"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/profession/profession.scss
 ** module id = 1304
 ** module chunks = 1
 **/